<template>
<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <card>
                    <h4 slot="header" class="card-title">Admin User Data</h4>
                    <form @submit.prevent="addNewUser">
                        <div class="row">
                            <div class="col-md-6">
                                <base-input type="text" label="Name" placeholder="Name" v-model="user.name"></base-input>
                            </div>
                            <div class="col-md-6">
                                <base-input type="text" label="Username" placeholder="Username" v-model="user.username"></base-input>
                            </div>
                            <div class="col-md-6">
                                <base-input type="password" label="Password" placeholder="Password" v-model="user.password"></base-input>
                            </div>
                            <div class="col-md-6">
                                <!-- Select input with options -->
                                <label for="roleSelect">Role</label>
                                <select class="form-control" id="roleSelect" v-model="user.role">
                                    <option value="" disabled>Select a role</option>
                                    <option v-for="option in roleOptions" :key="option.value" :value="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="submit" class="btn btn-primary btn-fill float-right btn-sm">
                                Add
                            </button>
                        </div>
                    </form>
                </card>
            </div>
            <div class="col-12">
                <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
                    <template slot="header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="card-title">User List</h4>
                                <!-- <p class="card-category">Here is a subtitle for this table</p> -->
                            </div>
                            <!-- <button @click="clearInput" class="btn btn-primary btn-sm">Add</button> -->
                        </div>
                    </template>
                    <template>
                        <div class="card-body">
                            <!-- Scrollable container -->
                            <div class="table-scroll-container">
                                <table id="myTable" class="table table-hover table-striped">
                                    <thead>
                                        <tr>
                                            <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in usersList" :key="index">
                                            <template v-if="editIndex === index">
                                                <td><input v-model="editItem.id" class="form-control" disabled /></td>
                                                <td><input v-model="editItem.name" class="form-control" /></td>
                                                <td><input v-model="editItem.username" class="form-control" /></td>
                                                <td>
                                                    <select class="form-control" v-model="editItem.role">
                                                        <option v-for="option in roleOptions" :key="option.value" :value="option.value">
                                                            {{ option.label }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <select class="form-control" v-model="editItem.status">
                                                        <option value="1">Active</option>
                                                        <option value="0">Deactivated</option>
                                                    </select>
                                                </td>
                                                <td><input v-model="editItem.created_datetime" class="form-control" disabled /></td>
                                                <td><input v-model="editItem.updated_datetime" class="form-control" disabled /></td>
                                                <td>
                                                    <button @click="saveUser(index)" class="btn btn-success btn-sm">Save</button>
                                                    <button @click="cancelEdit" class="btn btn-secondary btn-sm">Cancel</button>
                                                </td>
                                            </template>
                                            <template v-else>
                                                <td>{{ item.id }}</td>
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.username }}</td>
                                                <td>
                                                    <span class="badge" :class="getRoleBadgeClass(item.role)">
                                                        {{ getRoleLabel(item.role) }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="badge" :class="item.status == 1 ? 'badge-success' : 'badge-danger'">
                                                        {{ item.status == 1 ? 'Active' : 'Inactive' }}
                                                    </span>
                                                </td>
                                                <td>{{ formatDateTime(item.created_datetime) }}</td>
                                                <td>{{ formatDateTime(item.updated_datetime) }}</td>
                                                <td>
                                                    <button v-if="!item.currentUserLogined" @click="editUser(index, item)" class="btn btn-primary btn-sm" title="Edit User">
                                                        <i class="fa fa-edit"></i> Edit
                                                    </button>
                                                    <button v-if="!item.currentUserLogined" @click="showResetPasswordModal(item)" class="btn btn-warning btn-sm" title="Reset Password">
                                                        <i class="fa fa-key"></i> Reset
                                                    </button>
                                                    <button v-if="!item.currentUserLogined" @click="deleteUser(item.id)" class="btn btn-danger btn-sm" title="Delete User">
                                                        <i class="fa fa-trash"></i> Delete
                                                    </button>
                                                    <span v-if="item.currentUserLogined" class="badge badge-info">Current Login</span>
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </template>
                </card>
            </div>
        </div>
    </div>
    
    <!-- Reset Password Modal -->
    <div v-if="resetPasswordModal.show" class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Reset Password</h5>
                    <button type="button" class="close" @click="closeResetPasswordModal">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p><strong>User:</strong> {{ resetPasswordModal.username }}</p>
                    <div class="form-group">
                        <label>New Password</label>
                        <input type="password" class="form-control" v-model="resetPasswordModal.newPassword" 
                               placeholder="Enter new password" />
                    </div>
                    <div class="form-group">
                        <label>Confirm Password</label>
                        <input type="password" class="form-control" v-model="resetPasswordModal.confirmPassword" 
                               placeholder="Confirm new password" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeResetPasswordModal">Cancel</button>
                    <button type="button" class="btn btn-warning" @click="resetPassword" :disabled="loading">
                        {{ loading ? 'Resetting...' : 'Reset Password' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;">
        <div class="spinner-border text-light" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</div>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import axios from 'axios';
import {
    fetchUsers,
    resetUserPassword
} from 'src/utils/api';

export default {
    components: {
        Card
    },
    data() {
        return {
            editIndex: -1,
            editItem: {},
            selectedUsers: [],
            selectAll: false,
            user: {
                name: '',
                username: '',
                password: '',
                role: ''
            },
            resetPasswordModal: {
                show: false,
                userId: null,
                username: '',
                newPassword: '',
                confirmPassword: ''
            },
            roleOptions: [
                { value: 'viewer', label: 'Viewer (read-only)' },
                { value: 'member', label: 'Member' },
                { value: 'admin', label: 'Admin' }
            ],
            tableColumns: ['Id', 'Name', 'Username', 'Role', 'Status', 'Create At', 'Last Update', 'Action'],
            usersList: [],
            loading: false
        };
    },
    watch: {
        selectedUsers(val) {
            if (this.selectedUsers.length === this.usersList.length) {
                this.selectAll = true
            } else this.selectAll = false
        }
    },
    computed: {
        // currentUserLogined(){
        //     return localStorage.getItem('username') && localStorage.getItem('role')
        // }
    },
    methods: {
        clearInput() {
            this.user = {
                name: '',
                username: '',
                password: '',
                role: ''
            };
        },
        addNewUser() {
            if (this.user.name.trim() === '') {
                alert('Name cannot be empty');
                return;
            }
            if (this.user.username.trim() === '') {
                alert('Username cannot be empty');
                return;
            }
            if (!this.user.password || this.user.password.trim() === '') {
                alert('Password cannot be empty');
                return;
            }
            if (this.user.role.trim() === '') {
                alert('Role cannot be empty');
                return;
            }
            if (confirm(`Are you sure to create user "${this.user.name}"?`)) {
                this.loading = true;
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=createUser&type=user&platform=report`;
                axios.post(apiUrl, this.user)
                    .then(response => {
                        this.loading = false;
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.loadUsers();
                            this.clearInput();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        alert('Error: ' + (error.response && error.response.data && error.response.data.message || error.message || 'Failed to create user'));
                    });
            }
        },
        async loadUsers() {
            this.loading = true;
            try {
                if ($.fn.DataTable.isDataTable('#myTable')) {
                    $('#myTable').DataTable().clear().destroy();
                }
                let self = this;
                this.usersList = [];
                
                const data = await fetchUsers('admin');
                this.usersList = [...data];
                this.usersList.forEach(user => {
                    if(user.username == localStorage.getItem('username') && user.role == localStorage.getItem('role')){
                        user.currentUserLogined = true;
                    }
                    else user.currentUserLogined = false;
                });

                if(this.usersList.length > 0){
                    setTimeout(() => {
                        // Reinitialize DataTable
                        $('#myTable').DataTable({
                            pageLength: 10,
                            lengthMenu: [10, 25, 50, 100],
                            language: {
                                lengthMenu: "Show _MENU_ entries"
                            },
                            order: [[0, 'desc']] // Sort by ID descending (newest first)
                        });
                    }, self.usersList.length * 0.2);
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                alert('Error loading users: ' + (error.message || 'Unknown error'));
            }
        },
        saveUser(index) {
            if (confirm('Are you sure to update?')) {
                this.loading = true;
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=update&type=user&platform=report`;
                axios.post(apiUrl, this.editItem)
                    .then(response => {
                        this.loading = false;
                        if (response.data.status === 'success') {
                            this.$set(this.usersList, index, this.editItem);
                            this.cancelEdit();
                            alert(response.data.message);
                            this.loadUsers();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        alert('Network Error: ' + (error.response && error.response.data && error.response.data.message || error.message || error));
                    });
            }
        },
        editUser(index, item) {
            this.editIndex = index;
            this.editItem = {
                ...item
            };
        },
        cancelEdit() {
            this.editIndex = -1;
            this.editItem = {};
        },
        deleteUser(id) {
            if (confirm('Are you sure to delete this user?')) {
                this.loading = true;
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=delete&type=user&platform=report`;
                axios.post(apiUrl, {
                        ids: [id]
                    })
                    .then(response => {
                        this.loading = false;
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.loadUsers();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        alert('Network Error: ' + (error.response && error.response.data && error.response.data.message || error.message || error));
                    });
            }
        },
        showResetPasswordModal(user) {
            this.resetPasswordModal.show = true;
            this.resetPasswordModal.userId = user.id;
            this.resetPasswordModal.username = user.username;
            this.resetPasswordModal.newPassword = '';
            this.resetPasswordModal.confirmPassword = '';
        },
        closeResetPasswordModal() {
            this.resetPasswordModal.show = false;
            this.resetPasswordModal.userId = null;
            this.resetPasswordModal.username = '';
            this.resetPasswordModal.newPassword = '';
            this.resetPasswordModal.confirmPassword = '';
        },
        async resetPassword() {
            // Validation
            if (!this.resetPasswordModal.newPassword || this.resetPasswordModal.newPassword.trim() === '') {
                alert('Password cannot be empty');
                return;
            }
            if (this.resetPasswordModal.newPassword !== this.resetPasswordModal.confirmPassword) {
                alert('Passwords do not match');
                return;
            }
            
            if (confirm(`Reset password for user "${this.resetPasswordModal.username}"?`)) {
                this.loading = true;
                try {
                    const response = await resetUserPassword(this.resetPasswordModal.userId, this.resetPasswordModal.newPassword);
                    this.loading = false;
                    if (response.status === 'success') {
                        alert(response.message);
                        this.closeResetPasswordModal();
                        this.loadUsers();
                    } else {
                        alert('Error: ' + response.message);
                    }
                } catch (error) {
                    this.loading = false;
                    alert('Error: ' + (error.response && error.response.data && error.response.data.message || error.message || 'Failed to reset password'));
                }
            }
        },
        getRoleLabel(role) {
            const roleMap = {
                'viewer': 'Viewer',
                'member': 'Member',
                'admin': 'Admin',
                'developer': 'Developer'
            };
            return roleMap[role] || role;
        },
        getRoleBadgeClass(role) {
            const classMap = {
                'viewer': 'badge-secondary',
                'member': 'badge-info',
                'admin': 'badge-primary',
                'developer': 'badge-warning'
            };
            return classMap[role] || 'badge-secondary';
        },
        formatDateTime(datetime) {
            if (!datetime) return '-';
            const date = new Date(datetime);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    },
    mounted() {
        if(localStorage.getItem('role') !== 'admin' && localStorage.getItem('role') !== 'developer'){
            this.$router.push('/admin/report')
        }
        this.loadUsers();
    }
};
</script>

<style scoped>
.table-scroll-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
}

.table {
    min-width: 1000px;
}

.badge {
    padding: 0.25em 0.6em;
    font-size: 0.875em;
    font-weight: 600;
}

.badge-success {
    background-color: #28a745;
    color: white;
}

.badge-danger {
    background-color: #dc3545;
    color: white;
}

.badge-secondary {
    background-color: #6c757d;
    color: white;
}

.badge-info {
    background-color: #17a2b8;
    color: white;
}

.badge-primary {
    background-color: #007bff;
    color: white;
}

.badge-warning {
    background-color: #ffc107;
    color: #212529;
}

.btn-sm {
    margin: 2px;
}

.modal.show {
    display: block !important;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
